import React from 'react';
import * as R from 'ramda';

// Components
import { Box, Skeleton } from '@mui/material';

const SkeletonTable = () => {
  const renderSkeletonRow = R.times(i => (
    <Box borderBottom="1px solid rgba(0, 0, 0, 0.13)" height={48} key={i}>
      <Skeleton height="100%" variant="rectangular" width="100%" />
    </Box>
  ));

  return (
    <Box data-testid="skeleton" mb={5}>
      <Box height={32} width={144}>
        <Skeleton height="100%" variant="rectangular" width="100%" />
      </Box>
      <Box height={304} mt={2} width={716}>
        {renderSkeletonRow(6)}
      </Box>
    </Box>
  );
};

export default SkeletonTable;
